import React, { useEffect } from "react";

import useCategoryToProductsList from "../../apiHooks/useCategoryToProductsList";
import { API_STATUS } from "../../constants/app.constants";
import ErrorCard from "../error-card/error-card.component";
import IOTCategoryToApisList from "../iot-category-to-apis-list/iot-category-to-apis-list.component";

import Loader from "../loader/loader";

const  { LOADING, SUCCESS, ERROR } = API_STATUS;

const ApisListContainer = ({searchValue}) =>{


    const { status,  fetchCategoryToProductsList } = useCategoryToProductsList();
    useEffect( () => {
      fetchCategoryToProductsList();
    },[]);


    const renderScenarios = {
        [LOADING] :<Loader/>,
        [SUCCESS]: <IOTCategoryToApisList searchValue={searchValue}/>,
        [ERROR]: <ErrorCard onRefresh={fetchCategoryToProductsList}/>
    }

    return(
     <>
     
     {
         renderScenarios[status]
        
     }
     </>
    )

}

export default ApisListContainer;